import { j as t } from "../../../_virtual/jsx-runtime.js";
import * as s from "react";
import { cva as h } from "../../../node_modules/class-variance-authority/dist/index.js";
import { cn as m } from "../../../lib/utils.js";
import o from "../Icon/index.js";
import b from "../SkeletonWrapper/index.js";
const w = h(
  "inline-flex font-medium items-center justify-center gap-2 rounded-lg w-fit focus:outline-none focus:ring-0 hover:border-none border-none",
  {
    variants: {
      size: {
        iconSm: "h-6 w-6 px-1 py-2 text-sm",
        icon: "h-10 w-10 px-3 py-2",
        sm: "h-8 min-w-8 px-3 py-2 text-sm",
        md: "h-10 min-w-10 px-4 py-2",
        lg: "h-12 min-w-12 px-3.5 py-2"
      },
      bgColor: {
        default: "bg-neteera-teal-200 text-gray-900 hover:bg-neteera-teal-300",
        light: "bg-neteera-teal-200 text-gray-900 hover:bg-neteera-teal-300",
        white: "bg-white text-gray-900 hover:bg-neteera-teal-100",
        dark: "bg-neteera-teal-700 text-white hover:bg-neteera-teal-800",
        transparent: "bg-none text-gray-900 px-0"
      },
      isFull: {
        true: "w-full"
      },
      isRounded: {
        true: "rounded-full"
      },
      disabled: {
        true: "opacity-50 cursor-not-allowed"
      }
    },
    defaultVariants: {
      bgColor: "light",
      size: "lg",
      isFull: !1,
      isRounded: !1,
      disabled: !1
    }
  }
), y = s.forwardRef(
  ({
    className: e,
    bgColor: i,
    size: l,
    isFull: r,
    isRounded: a,
    isLoading: u,
    disabled: n,
    children: d,
    leftIconProps: f,
    rightIconProps: p,
    ...x
  }, g) => /* @__PURE__ */ t.jsx(
    b,
    {
      isLoading: u,
      full: r || (e == null ? void 0 : e.includes("flex-1")) || (e == null ? void 0 : e.includes("w-full")),
      children: /* @__PURE__ */ t.jsxs(
        "button",
        {
          className: m(
            w({
              bgColor: i,
              size: l,
              isFull: r,
              isRounded: a,
              disabled: n,
              className: e
            })
          ),
          ref: g,
          disabled: n,
          ...x,
          children: [
            /* @__PURE__ */ t.jsx(o, { ...f }),
            d,
            r && /* @__PURE__ */ t.jsx("div", { className: "flex-1" }),
            /* @__PURE__ */ t.jsx(o, { ...p })
          ]
        }
      )
    }
  )
);
y.displayName = "Button";
export {
  y as default
};
